var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mediapool-list",staticStyle:{"overflow":"visible"}},_vm._l((_vm.files),function(screenshot){return _c('div',{key:screenshot.clientId,staticClass:"file-box mediapool-file-box"},[_c('screenshot-element',{attrs:{"screenshotData":_vm.typedScreenshot(screenshot)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }